import { Injectable, inject } from '@angular/core';
import { getModule } from '@placeos/ts-client';

import { AsyncHandler } from './async-handler.class';
import { SettingsService } from './settings.service';

@Injectable({
    providedIn: 'root',
})
export class VorlonService extends AsyncHandler {
    private _settings = inject(SettingsService);

    /** DOM Element containing the Vorlon Script */
    private _script: HTMLScriptElement;

    constructor() {
        super();
        this.load();
    }

    private async load() {
        const system = this._settings.get('app.vorlon.system');
        if (system) {
            const module = getModule(system, 'Vorlon');
            if (module) {
                const binding = module.variable('enabled');
                this.subscription(
                    'binding_value',
                    binding.bindThenSubscribe((state) => {
                        state
                            ? this.injectVorlonScript()
                            : this.removeVorlonScript();
                    }),
                );
            }
        }
    }

    private injectVorlonScript() {
        this.removeVorlonScript();
        this._script = document.createElement('script');
        const url = this._settings.get('app.vorlon.url');
        this._script.src = url || `./assets/vorlon.js`;
        document.head.appendChild(this._script);
    }

    private removeVorlonScript() {
        if (this._script) {
            this._script.parentNode.removeChild(this._script);
            delete this._script;
            this._script = null;
        }
    }
}
